<div class="customers-container">
  <div class="header">
    <div class="header-content">
      <div>
        <h1>Customers</h1>
        <p>Manage and view all customer information</p>
      </div>
      <a routerLink="/customers/create" class="create-customer-btn">
        <i class="fas fa-plus"></i> Create Customer
      </a>
    </div>
  </div>

  <!-- Segment Selection Tabs -->
  <div class="segment-tabs">
    <button class="segment-tab" [class.active]="filters.segment === 'all'" (click)="selectSegment('all')">
      <i class="fas fa-users"></i> All Customers
    </button>
    <button class="segment-tab active-regulars" [class.active]="filters.segment === 'active_regulars'" (click)="selectSegment('active_regulars')">
      <i class="fas fa-user-check"></i> Active Regulars
    </button>
    <button class="segment-tab churned-regulars" [class.active]="filters.segment === 'churned_regulars'" (click)="selectSegment('churned_regulars')">
      <i class="fas fa-user-slash"></i> Churned Regulars
    </button>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
    <div class="filter-header">
      <h3><i class="fas fa-filter"></i> Filter Customers</h3>
      <button class="clear-filters-btn" (click)="clearFilters()" [disabled]="!hasActiveFilters()">
        <i class="fas fa-times"></i> Clear Filters
      </button>
    </div>
    
    <div class="filter-form">
      <div class="filter-row">
        <div class="filter-group">
          <label for="nameFilter">Name</label>
          <input 
            type="text" 
            id="nameFilter"
            [(ngModel)]="filters.name" 
            placeholder="Search by customer name..."
            (input)="onFilterChange()"
            class="filter-input">
        </div>
        
        <div class="filter-group">
          <label for="phoneFilter">Phone Number</label>
          <input 
            type="text" 
            id="phoneFilter"
            [(ngModel)]="filters.phoneNumber" 
            placeholder="Search by phone number..."
            (input)="onFilterChange()"
            class="filter-input">
        </div>
        
        <div class="filter-group">
          <label for="addressFilter">Address</label>
          <input 
            type="text" 
            id="addressFilter"
            [(ngModel)]="filters.addressText" 
            placeholder="Search by address..."
            (input)="onFilterChange()"
            class="filter-input">
        </div>
      </div>
      
      <div class="filter-row">
        <div class="filter-group">
          <label for="upiFilter">UPI ID Status</label>
          <select 
            id="upiFilter"
            [(ngModel)]="filters.hasUpiId" 
            (change)="onFilterChange()"
            class="filter-select">
            <option value="">All Customers</option>
            <option value="true">Has UPI ID</option>
            <option value="false">No UPI ID</option>
          </select>
        </div>
        
        <div class="filter-group">
          <label for="minCollectionsFilter">Min Collections</label>
          <input 
            type="number" 
            id="minCollectionsFilter"
            [(ngModel)]="filters.minCollections" 
            placeholder="e.g. 3"
            (input)="onFilterChange()"
            class="filter-input">
        </div>

        <div class="filter-group">
          <label for="minAmountFilter">Min Amount (₹)</label>
          <input 
            type="number" 
            id="minAmountFilter"
            [(ngModel)]="filters.minCollectionAmount" 
            placeholder="e.g. 500"
            (input)="onFilterChange()"
            class="filter-input">
        </div>
      </div>

      <div class="filter-row">
        <div class="filter-group">
          <label for="lastBeforeFilter">Last Collection Before</label>
          <input 
            type="date" 
            id="lastBeforeFilter"
            [(ngModel)]="filters.lastCollectionBefore" 
            (change)="onFilterChange()"
            class="filter-input">
        </div>

        <div class="filter-group">
          <label for="lastAfterFilter">Last Collection After</label>
          <input 
            type="date" 
            id="lastAfterFilter"
            [(ngModel)]="filters.lastCollectionAfter" 
            (change)="onFilterChange()"
            class="filter-input">
        </div>
        
        <div class="filter-actions">
          <button class="apply-filters-btn" (click)="applyFilters()" [disabled]="!hasActiveFilters()">
            <i class="fas fa-search"></i> Apply Filters
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="table-container" *ngIf="(customers$ | async) as customersResponse">
    <!-- Pagination Summary -->
    <div class="pagination-summary">
      <p>Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalCount || 0) }} of {{ totalCount || 0 }} customers</p>
    </div>
    
    <!-- Desktop Table View -->
    <div class="table-wrapper">
      <table class="customers-table">
        <thead>
          <tr>
            <th>Customer ID</th>
            <th>Name</th>
            <th>Phone Number</th>
            <th>Primary Address</th>
            <th style="text-align: right;">Collections</th>
            <th style="text-align: right;">Total Value</th>
            <th>Last Collection</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let customer of customersResponse?.items || []">
            <!-- Main row -->
            <tr class="customer-row" [class.expanded]="isRowExpanded(customer.customerId)">
              <td>{{ customer.customerId }}</td>
              <td>{{ customer.name }}</td>
              <td>{{ customer.phoneNumber }}</td>
              <td>
                <span *ngIf="getPrimaryAddress(customer) as primaryAddress">
                  {{ primaryAddress.address }}, {{ primaryAddress.locationName }} - {{ primaryAddress.pincode }}
                </span>
                <span *ngIf="!getPrimaryAddress(customer)" class="no-address">No address available</span>
              </td>
              <td style="text-align: right; font-weight: 600; color: #374151;">
                {{ customer.totalCollections || 0 }}
              </td>
              <td style="text-align: right; font-weight: 600; color: #10b981;">
                ₹{{ (customer.totalCollectionAmount || 0).toFixed(2) }}
              </td>
              <td style="color: #4b5563;">
                {{ customer.lastCollectionDate ? (customer.lastCollectionDate | date:'dd-MMM-yyyy hh:mm a') : 'Never' }}
              </td>
              <td>
                <div class="action-buttons" *ngIf="deletingCustomerId !== customer.customerId">
                  <button 
                    class="expand-btn" 
                    (click)="toggleRow(customer.customerId)"
                    [class.expanded]="isRowExpanded(customer.customerId)" title="expand to see addresses">
                    {{ isRowExpanded(customer.customerId) ? '▼' : '▶' }}
                  </button>
                  <button 
                    class="create-appointment-btn"
                    (click)="openAppointmentModal(customer)"
                    title="Create Appointment">
                    <i class="fas fa-calendar-plus"></i>
                  </button>
                  <button 
                    class="update-fees-btn"
                    (click)="openUpdateFeesModal(customer)"
                    title="Update Customer Fees">
                    <i class="fas fa-dollar-sign"></i>
                  </button>
                  <button 
                    class="delete-customer-btn"
                    (click)="promptDeleteCustomer(customer.customerId)"
                    title="Delete Customer">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
                <div class="inline-confirmations delete-confirmation" *ngIf="deletingCustomerId === customer.customerId">
                  <span class="warning-text" title="Warning: This action will delete and anonymize the customer's data!"><i class="fas fa-exclamation-triangle"></i> Delete & anonymize data?</span>
                  <div class="confirmation-actions">
                    <button class="confirm-btn" (click)="confirmDeleteCustomer(customer)" [disabled]="isDeletingCustomer">
                      <i class="fas" [ngClass]="isDeletingCustomer ? 'fa-spinner fa-spin' : 'fa-check'"></i>
                      {{ isDeletingCustomer ? 'Deleting...' : 'Yes' }}
                    </button>
                    <button class="cancel-btn" (click)="cancelDeleteCustomer()" [disabled]="isDeletingCustomer">
                      <i class="fas fa-times"></i> No
                    </button>
                  </div>
                </div>
              </td>
            </tr>
            
            <!-- Expanded row with addresses -->
            <tr class="address-row" *ngIf="isRowExpanded(customer.customerId)">
              <td colspan="5">
                <div class="addresses-container">
                  <div class="addresses-header">
                    <h4>All Addresses ({{ customer.customerAddress?.length || 0 }})</h4>
                    <button 
                      class="add-address-btn"
                      (click)="openAddAddressModal(customer)"
                      title="Add New Address">
                      <i class="fas fa-plus"></i> Add Address
                    </button>
                  </div>
                  <div class="addresses-grid">
                    <div 
                      *ngFor="let address of customer.customerAddress || []" 
                      class="address-card"
                      [class.primary]="address.isPrimary">
                      <div class="address-header">
                        <span class="address-type" *ngIf="address.isPrimary">Primary Address</span>
                        <span class="address-type" *ngIf="!address.isPrimary">Secondary Address</span>
                        <span class="address-badge" [ngClass]="'badge-' + address.addressType.toLowerCase()" *ngIf="address.addressType">
                          <i class="fas" [ngClass]="{'fa-home': address.addressType === 'Home', 'fa-building': address.addressType === 'Office', 'fa-map-marker-alt': address.addressType === 'Other'}"></i>
                          {{ address.addressType }}
                        </span>
                      </div>
                      <div class="address-content">
                        <p class="address-text">{{ address.address }}</p>
                        <p class="location-info">{{ address.locationName }}</p>
                        <p class="pincode">Pincode: {{ address.pincode }}</p>
                        <p class="coordinates">
                          Coordinates: {{ address.location.latitude | number:'1.6-6' }}, {{ address.location.longitude | number:'1.6-6' }}
                        </p>
                      </div>
                      <div class="address-actions">
                        <button 
                          class="edit-address-btn"
                          (click)="openEditAddressModal(address)"
                          title="Edit Address">
                          <i class="fas fa-edit"></i> Edit
                        </button>
                        <button 
                          class="mark-primary-btn"
                          *ngIf="!address.isPrimary"
                          (click)="markAddressAsPrimary(address.addressId, customer.customerId)"
                          title="Mark as Primary Address">
                          <i class="fas fa-star"></i> Mark as Primary
                        </button>
                        <button 
                          class="delete-address-btn"
                          (click)="deleteAddress(address.addressId, customer.customerId)"
                          title="Delete Address">
                          <i class="fas fa-trash"></i> Delete
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Mobile Card View -->
    <div class="mobile-cards">
      <ng-container *ngFor="let customer of customersResponse?.items || []">
        <div class="customer-card" [class.expanded]="isRowExpanded(customer.customerId)">
          <div class="customer-card-header">
            <div class="customer-card-info">
              <h3 class="customer-name">{{ customer.name }}</h3>
              <p class="customer-id">ID: {{ customer.customerId }}</p>
            </div>
            <div class="customer-card-actions" *ngIf="deletingCustomerId !== customer.customerId">
              <button 
                class="expand-btn mobile-expand-btn" 
                (click)="toggleRow(customer.customerId)"
                [class.expanded]="isRowExpanded(customer.customerId)" 
                title="expand to see addresses">
                {{ isRowExpanded(customer.customerId) ? '▼' : '▶' }}
              </button>
              <button 
                class="create-appointment-btn mobile-appointment-btn"
                (click)="openAppointmentModal(customer)"
                title="Create Appointment">
                <i class="fas fa-calendar-plus"></i>
              </button>
              <button 
                class="update-fees-btn mobile-fees-btn"
                (click)="openUpdateFeesModal(customer)"
                title="Update Customer Fees">
                <i class="fas fa-dollar-sign"></i>
              </button>
              <button 
                class="delete-customer-btn mobile-delete-btn"
                (click)="promptDeleteCustomer(customer.customerId)"
                title="Delete Customer">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
          <div class="mobile-delete-confirmation" *ngIf="deletingCustomerId === customer.customerId">
            <div class="warning-text"><i class="fas fa-exclamation-triangle"></i> Warning: This action will delete and anonymize the customer's data! Are you sure?</div>
            <div class="confirmation-actions">
              <button class="cancel-btn" (click)="cancelDeleteCustomer()" [disabled]="isDeletingCustomer">
                <i class="fas fa-times"></i> Cancel
              </button>
              <button class="confirm-btn" (click)="confirmDeleteCustomer(customer)" [disabled]="isDeletingCustomer">
                <i class="fas" [ngClass]="isDeletingCustomer ? 'fa-spinner fa-spin' : 'fa-check'"></i> 
                {{ isDeletingCustomer ? 'Deleting...' : 'Proceed' }}
              </button>
            </div>
          </div>
          
          <div class="customer-card-body">
            <div class="customer-detail-row">
              <span class="detail-label"><i class="fas fa-phone"></i> Phone:</span>
              <span class="detail-value">{{ customer.phoneNumber }}</span>
            </div>
            <div class="customer-detail-row">
              <span class="detail-label"><i class="fas fa-map-marker-alt"></i> Address:</span>
              <span class="detail-value">
                <span *ngIf="getPrimaryAddress(customer) as primaryAddress">
                  {{ primaryAddress.address }}, {{ primaryAddress.locationName }} - {{ primaryAddress.pincode }}
                </span>
                <span *ngIf="!getPrimaryAddress(customer)" class="no-address">No address available</span>
              </span>
            </div>
          </div>

          <!-- Expanded addresses section for mobile -->
          <div class="customer-card-addresses" *ngIf="isRowExpanded(customer.customerId)">
            <div class="addresses-container">
              <div class="addresses-header">
                <h4>All Addresses ({{ customer.customerAddress?.length || 0 }})</h4>
                <button 
                  class="add-address-btn"
                  (click)="openAddAddressModal(customer)"
                  title="Add New Address">
                  <i class="fas fa-plus"></i> Add Address
                </button>
              </div>
              <div class="addresses-grid">
                <div 
                  *ngFor="let address of customer.customerAddress || []" 
                  class="address-card"
                  [class.primary]="address.isPrimary">
                  <div class="address-header">
                    <span class="address-type" *ngIf="address.isPrimary">Primary Address</span>
                    <span class="address-type" *ngIf="!address.isPrimary">Secondary Address</span>
                    <span class="address-badge" [ngClass]="'badge-' + address.addressType.toLowerCase()" *ngIf="address.addressType">
                      <i class="fas" [ngClass]="{'fa-home': address.addressType === 'Home', 'fa-building': address.addressType === 'Office', 'fa-map-marker-alt': address.addressType === 'Other'}"></i>
                      {{ address.addressType }}
                    </span>
                  </div>
                  <div class="address-content">
                    <p class="address-text">{{ address.address }}</p>
                    <p class="location-info">{{ address.locationName }}</p>
                    <p class="pincode">Pincode: {{ address.pincode }}</p>
                    <p class="coordinates">
                      Coordinates: {{ address.location.latitude | number:'1.6-6' }}, {{ address.location.longitude | number:'1.6-6' }}
                    </p>
                  </div>
                  <div class="address-actions">
                    <button 
                      class="edit-address-btn"
                      (click)="openEditAddressModal(address)"
                      title="Edit Address">
                      <i class="fas fa-edit"></i> Edit
                    </button>
                    <button 
                      class="mark-primary-btn"
                      *ngIf="!address.isPrimary"
                      (click)="markAddressAsPrimary(address.addressId, customer.customerId)"
                      title="Mark as Primary Address">
                      <i class="fas fa-star"></i> Mark as Primary
                    </button>
                    <button 
                      class="delete-address-btn"
                      (click)="deleteAddress(address.addressId, customer.customerId)"
                      title="Delete Address">
                      <i class="fas fa-trash"></i> Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="loading" *ngIf="!(customers$ | async)">
    <p>Loading customers...</p>
  </div>

  <div class="error" *ngIf="(customers$ | async) as customersResponse">
    <p *ngIf="!customersResponse.items || customersResponse.items.length === 0">No customers found.</p>
  </div>

  <!-- Pagination Component -->
  <app-pagination
    *ngIf="(customers$ | async) as customersResponse"
    [page]="currentPage"
    [totalPages]="totalPages"
    [pageSize]="pageSize"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)">
  </app-pagination>

  <!-- Add Customer Address Modal -->
  <app-add-customer-address
    *ngIf="showAddAddressModal && selectedCustomerForAddress"
    [customer]="selectedCustomerForAddress"
    [customerId]="selectedCustomerForAddress.customerId"
    [showModal]="showAddAddressModal"
    (addressCreated)="onAddressCreated()"
    (closeModal)="closeAddAddressModal()">
  </app-add-customer-address>

  <!-- Edit Customer Address Modal -->
  <app-edit-customer-address
    *ngIf="showEditAddressModal && selectedAddress"
    [address]="selectedAddress"
    [showModal]="showEditAddressModal"
    (addressUpdated)="onAddressUpdated()"
    (closeModal)="closeEditAddressModal()">
  </app-edit-customer-address>

  <!-- Update Customer Fees Modal -->
  <app-update-customer-fees
    *ngIf="showUpdateFeesModal && selectedCustomerForFees"
    [customer]="selectedCustomerForFees"
    [showModal]="showUpdateFeesModal"
    (feesUpdated)="onFeesUpdated()"
    (closeModal)="closeUpdateFeesModal()">
  </app-update-customer-fees>
</div> 